// extracted by mini-css-extract-plugin
export default {"popUp":"style_popUp__LvGVZ","cbnFooterContainer":"style_cbnFooterContainer__0gVS-"};